import { useTranslation } from 'libs/i18n';
import { Stack } from 'libs/ui';

import {
  W8BenFormFormType,
  FormErrors,
  getSchema,
} from '../../forms/w8BenFormForm';
import { ClientType, FormBodyWrapper } from '../FormBodyWrapper';

import { FormContent, FormContentProps } from './FormContent';
import { SubTitle } from './SubTitle';

interface Props extends FormContentProps {
  initialValues?: W8BenFormFormType;
  onSubmit: (values: W8BenFormFormType) => void;
  canGoBack?: boolean;
  onGoBack?: () => void;
  formError?: FormErrors;
  submitLoading?: boolean;
  submitDisabled?: boolean;
  clientType?: ClientType;
  formType: 'W8BENForm' | 'W8BENEForm';
}

export const W8BenForm = ({
  initialValues,
  canGoBack,
  submitLoading,
  submitDisabled,
  formError,
  onGoBack,
  onSubmit,
  clientType,
  formType,
  ...formProps
}: Props) => {
  const { t } = useTranslation();
  const schema = getSchema();
  return (
    <FormBodyWrapper
      canGoBack={canGoBack}
      clientType={clientType}
      initialErrors={formError}
      initialValues={initialValues}
      submitDisabled={submitDisabled}
      submitLoading={submitLoading}
      subTitleContent={<SubTitle formType={formType} />}
      title={t(`onboarding.${formType}.title`)}
      validationSchema={schema}
      onGoBack={onGoBack}
      onSubmit={onSubmit}
    >
      <Stack spacing={32}>
        <FormContent formType={formType} {...formProps} />
      </Stack>
    </FormBodyWrapper>
  );
};
